import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposSocioConstant } from 'constants/index'

const TipoSocioFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO SOCIO' htmlFor='select-tipoSocio' md={2} alignRightAt='md' />
      <Col md={10}>
        <Field name='tipoSocio'>
          {({ field }) => (
            <Form.Select {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-tipoSocio'>
              <option value=''>Seleccionar</option>
              {TiposSocioConstant.__arrayCP.map((val, key) => (
                <option key={key} value={val.id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoSocioFormGroup)
